function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHotelHotelFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.857 6.733c-.192.116-.362-.007-.31-.226l.302-1.3-1.01-.875c-.169-.147-.105-.346.12-.365l1.33-.113.518-1.226c.088-.207.297-.207.385 0l.52 1.226 1.33.113c.223.019.288.218.118.365l-1.01.875.304 1.3c.05.219-.119.342-.31.226L16 6.043l-1.143.69zM8.35 7.438c-.013.224.176.315.344.168L9.7 6.729l1.246.48c.21.08.354-.07.267-.277l-.525-1.228.842-1.036c.143-.176.044-.36-.18-.34l-1.329.12-.725-1.118c-.123-.188-.328-.15-.378.067L8.62 4.697l-1.29.341c-.217.058-.246.266-.054.38l1.147.688-.073 1.332zM15 18.536h-4v-2h4v2zM21 18.536h-4v-2h4v2zM21 22.536h-4v-2h4v2zM11 22.536h4v-2h-4v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 27.527v-12.99h1v-2h-4v-2h2v-2H8v2h2v2H6v2h1v12.99H5v2h22v-2h-2zm-2 0h-3v-3.99h-8v3.99H9v-12.99h14v12.99zm-9 0h4v-1.99h-4v1.99zm-2-14.99h8v-2h-8v2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.787 6.933c-.088.205.057.357.267.276l1.245-.48 1.006.877c.17.147.357.056.345-.168l-.073-1.333 1.146-.688c.194-.114.164-.322-.053-.38l-1.29-.341-.299-1.298c-.05-.22-.256-.255-.379-.068l-.724 1.117-1.329-.12c-.224-.018-.323.165-.18.34l.842 1.038-.524 1.228z",
    fill: props.color
  }));
}

export default SvgIconHotelHotelFilled;